import { useMutation } from '@tanstack/react-query';

import { EnableIsHotDialogNotificationData, PLATFORM_URL_SEGMENT } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const enableIsHotDialogNotification = (
  data: EnableIsHotDialogNotificationData
): Promise<void> => {
  return axios.post(
    `/${PLATFORM_URL_SEGMENT[data.platform]}/pages/enable-hot-dialog-notification`,
    data
  );
};

type EnableIsHotDialogNotificationOptions = {
  config?: MutationConfig<typeof enableIsHotDialogNotification>;
};

export function useEnableIsHotDialogNotification({
  config,
}: EnableIsHotDialogNotificationOptions = {}) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['pages']);
    },
    ...config,
    mutationFn: enableIsHotDialogNotification,
  });
}
